import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../../../NavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated} from "vue";
import { useI18n } from "vue3-i18n";
import { store } from "@/store/store";
import { useRouter } from "vue-router";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import SalesNoteLinkNavigation from "../../../KDPSalesNoteLinkNavigationContainer.vue";
import SalesNoteHeaderNavigation from "../../../KDPSalesNoteHeaderNavigationContainer.vue";
import IssueSalesNoteDataService from "@/services/KDPIssueSalesNoteDataService";
import ResponseData from "@/types/ResponseData";
import KDPSalesNote from "@/types/KDPSalesNote";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const router = useRouter();
const txtUserId = ref("");
const modalSubject = reactive([]);
const modalBody = reactive([]);
const isCheckedOK = ref(true);
const isChecked = ref("");
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const smcConfirmerId = ref("");
const approverId = ref("");
const approverDataId = ref("");
const distributorConfirmer1Id = ref("");
const distributorConfirmer2Id = ref("");
const distributorConfirmer3Id = ref("");
const distributorConfirmer4Id = ref("");
const distributorConfirmer5Id = ref("");
const distributorConfirmer1IdName = ref("");
const distributorConfirmer2IdName = ref("");
const distributorConfirmer3IdName = ref("");
const distributorConfirmer4IdName = ref("");
const distributorConfirmer5IdName = ref("");
const distributorApproverIdName = ref("");
const distributorApproverId = ref("");
const distributorApproverName= ref("");
const distributorApproverNameData= ref("");
const confirmNameData= ref("");
const distributorCode = ref("");
const Clear1disable = ref(true);
const Change2disable = ref(true);
const Clear2disable = ref(true);
const Change3disable = ref(true);
const Clear3disable = ref(true);
const Change4disable = ref(true);
const Clear4disable = ref(true);
const Change5disable = ref(true);
const Clear5disable = ref(true);
const Ketteidisable = ref(true);
const menuCD = ref("");
const radioCheckUserId = ref("");
const radioCheckUserName = ref("");
const checkUser = ref("");
const confirmerId = ref("");
const saleNoDataList = ref([]);
const prodYmDataList = ref([]);
const seqNoDataList = ref([]);
const distributorDataList = ref([]);
const btnFlag = ref("");
const stationData = ref("");
const approverStation = ref("");
const parentDistributorCode = ref("");
const distributorName = ref("");

const paramSalesNote = reactive<KDPSalesNote[]>([]);
const distributorCodeCheck = ref("");
const distributorCodeData = ref("");

onMounted(function () {
  menuCD.value = store.getters.mainMenuCode;
  /** パラメータ取得 */
  paramSalesNote.splice(0);
  paramSalesNote.push(...store.getters.paramKDPSalesNoteList);
  for (const info of paramSalesNote){
    distributorCode.value =info['distCD']
    parentDistributorCode.value =info['parentCD']
  }  
  const paramCheckDistMode = store.getters.kdpSalesNoteSearchData || null;
  distributorCodeCheck.value =paramCheckDistMode.selectedDistMode;
  if (distributorCodeCheck.value == '0'){
    distributorCodeData.value = parentDistributorCode.value;
  }
  else{
    distributorCodeData.value = distributorCode.value;
  }
  getIssueSalesNoteList();
});

const getIssueSalesNoteList = () => {
  isLoading.value=true;
  alertMessage.value = "null";
  alertState.value = "neutral";

  const data = {
    distributorCodeData: distributorCodeData.value,
    userId : store.getters.cognitoUserName
  };

  IssueSalesNoteDataService.getScanUserNameForApproval(data)
  .then((response: ResponseData) => {
    if(response.data.message == "success"){
      const info = response.data.data;
      if(info.smcConfirmer.smcConfirmerId_id != null){
        smcConfirmerId.value = info.smcConfirmer ? `${info.smcConfirmer.givenName || ""} ${info.smcConfirmer.familyName || ""} (${info.smcConfirmer.smcConfirmerId_id})` : "";
        confirmNameData.value = `${info.smcConfirmer.givenName || ''} ${info.smcConfirmer.familyName || ''} ` ;
        confirmerId.value = info.smcConfirmer.smcConfirmerId_id;
      }
      if(info.approver.approverId_id != null){
        approverId.value = `${info.approver.givenName} ${info.approver.familyName || ''} (${info.approver.approverId_id || ''})`;
        distributorApproverNameData.value = `${info.approver.givenName || ''} ${info.approver.familyName || ''} ` ;
        approverDataId.value = info.approver.approverId_id;
      }
      if(info.distributorConfirmer1.distributorConfirmer1Id_id != null){
          distributorConfirmer1Id.value = `${info.distributorConfirmer1.givenName || ''} ${info.distributorConfirmer1.familyName || ''} (${info.distributorConfirmer1.distributorConfirmer1Id_id || ''}) \n \t ` + 
                                            `(${info.distributorConfirmer1.stationCode || ''} : ${info.distributorConfirmer1.companyName || ''})`;
        distributorConfirmer1IdName.value =  info.distributorConfirmer1.distributorConfirmer1Id_id;
      }
      if(info.distributorConfirmer2.distributorConfirmer2Id_id != null){
          distributorConfirmer2Id.value = `${info.distributorConfirmer2.givenName || ''} ${info.distributorConfirmer2.familyName || ''} (${info.distributorConfirmer2.distributorConfirmer2Id_id || ''}) \n` +
                                              `(${info.distributorConfirmer2.stationCode || ''} : ${info.distributorConfirmer2.companyName || ''})`;
        distributorConfirmer2IdName.value =  info.distributorConfirmer2.distributorConfirmer2Id_id;
      }
      if(info.distributorConfirmer3.distributorConfirmer3Id_id != null){
          distributorConfirmer3Id.value = `${info.distributorConfirmer3.givenName || ''} ${info.distributorConfirmer3.familyName || ''} (${info.distributorConfirmer3.distributorConfirmer3Id_id || ''}) \n` +
                                              `(${info.distributorConfirmer3.stationCode || ''} : ${info.distributorConfirmer3.companyName || ''})`;
        distributorConfirmer3IdName.value =  info.distributorConfirmer3.distributorConfirmer3Id_id;    
      }
      if(info.distributorConfirmer4.distributorConfirmer4Id_id != null){
          distributorConfirmer4Id.value = `${info.distributorConfirmer4.givenName || ''} ${info.distributorConfirmer4.familyName || ''} (${info.distributorConfirmer4.distributorConfirmer4Id_id || ''}) \n` +
                                              `(${info.distributorConfirmer4.stationCode || ''} : ${info.distributorConfirmer4.companyName || ''})`;
        distributorConfirmer4IdName.value =  info.distributorConfirmer4.distributorConfirmer4Id_id;
      }
      if(info.distributorConfirmer5.distributorConfirmer5Id_id != null){
          distributorConfirmer5Id.value = `${info.distributorConfirmer5.givenName || ''} ${info.distributorConfirmer5.familyName || ''} (${info.distributorConfirmer5.distributorConfirmer5Id_id || ''}) \n` +
                                              `(${info.distributorConfirmer5.stationCode || ''} : ${info.distributorConfirmer5.companyName || ''})`;
        distributorConfirmer5IdName.value =  info.distributorConfirmer5.distributorConfirmer5Id_id;
      }    
      if(info.distributorApprover.distributorApproverId_id != null){            
        distributorApproverId.value = info.distributorApprover ? `${info.distributorApprover.givenName || ''} ${info.distributorApprover.familyName || ''} (${info.distributorApprover.distributorApproverId_id || ''}) \n` +
                                                `(${info.distributorApprover.stationCode || ''} : ${info.distributorApprover.companyName || ''})` : '';
        distributorApproverIdName.value = info.distributorApprover.distributorApproverId_id;
      }
    }
    checkBtnStart();
    checkBtnClear();
    isLoading.value=false;
  })
  .catch((e: Error) => {
    btnFlag.value = "";
    alertMessage.value = i18n.t("err103");
    alertState.value = "error";
    isLoading.value=false;
  }); 
 }

const mailSendProcess =  () => {
  mailData();
}

const mailData =  () => {
  saleNoDataList.value = [];
  prodYmDataList.value = [];
  seqNoDataList.value = [];
  distributorDataList.value = [];
  alertMessage.value = "null";
  alertState.value = "neutral";
  if(confirmerId.value.length != 0){
    distributorApproverName.value = confirmNameData.value ;
  }
  else{
    distributorApproverName.value = distributorApproverNameData.value ;
  }
  for (const info of paramSalesNote){
    saleNoDataList.value.push(info["salesNo"]);
    prodYmDataList.value.push(info["prodYM"]);
    seqNoDataList.value.push(info["seqNo"]);
    distributorDataList.value.push(info["distCD"]);
  }
  isLoading.value = true;
  const dataLambda = { 
      functionName : "getDistributorName",
      distCd : parentDistributorCode.value
    };
    IssueSalesNoteDataService.getDistributorName(dataLambda)
    .then((response) => {
      distributorName.value = response.data.distributor_name;
      const saleNoteForDistrNameList = {
        drafterId : store.getters.cognitoUserName,
        approverId : approverDataId.value,
        smcConfirmerId : confirmerId.value,
        distrId : distributorApproverIdName.value,
        confirmer1Id : distributorConfirmer1IdName.value,
        confirmer2Id : distributorConfirmer2IdName.value,
        confirmer3Id : distributorConfirmer3IdName.value,
        confirmer4Id : distributorConfirmer4IdName.value,
        confirmer5Id : distributorConfirmer5IdName.value,
        saleNoData : saleNoDataList.value,
        prodYm :prodYmDataList.value,
        seqNo : seqNoDataList.value,
        distributorCode : distributorDataList.value,
        distributorName : distributorName.value,
        menuCD : menuCD.value
      }  
      IssueSalesNoteDataService.updateKDPSaleNoteApproval(saleNoteForDistrNameList)
      .then((response: ResponseData) => {
        if (response.data.message == 'success') {
          isLoading.value = false;
          btnFlag.value = (document.getElementById("hidbtn") as HTMLInputElement).value;          
        }
      })
      .catch((e: Error) => {
        const message = e?.response?.data?.message || e.message;
        if (message == 'fail to send') {
          btnFlag.value = "";
          alertMessage.value = i18n.t("err106");
          alertState.value = "error";
          isLoading.value = false;
        }
        else if (message == 'fail to update') {
          btnFlag.value = "";
          alertMessage.value = i18n.t("err105");
          alertState.value = "error";
          isLoading.value = false;
        }
        else{
          btnFlag.value = "";
          alertMessage.value = i18n.t("err104");
          alertState.value = "error";
          isLoading.value = false;
        }
      }); 
    })
    .catch((error: ResponseData) => {
      alertMessage.value = i18n.t("err109");
      alertState.value = "error";
      isLoading.value = false;
    });
}

onUpdated(function () {
  try {
    var dataHeight = document.getElementById("tbltbody")?.clientHeight;
    if (dataHeight != 0) {
      var tableHeight = document.getElementById("tblbodydiv")?.clientHeight;
      if (dataHeight > tableHeight) {
        document.getElementById("tblbodydiv").style.width = "100%";
        document.getElementById("tblbodydiv").style.borderBottom = "#ccc solid 0.5px";
      } else {
        document.getElementById("tblbodydiv").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    console.log(e);
  }
});

const checkBtnClear = () => {
  if(distributorConfirmer1Id.value.length != 0){
      Clear1disable.value = false;
      Clear2disable.value = true;
      Clear3disable.value = true;
      Clear4disable.value = true;
      Clear5disable.value = true;
      Change2disable.value = false;
      Change3disable.value = true;
      Change4disable.value = true;
      Change5disable.value = true;
    } 
    if(distributorConfirmer2Id.value.length != 0){
      Clear1disable.value = true;
      Clear2disable.value = false;
      Clear3disable.value = true;
      Clear4disable.value = true;
      Clear5disable.value = true;
      Change2disable.value = false;
      Change3disable.value = false;
      Change4disable.value = true;
      Change5disable.value = true;
    } 
    
    if(distributorConfirmer3Id.value.length != 0){
      Clear1disable.value = true;
      Clear2disable.value = true;
      Clear3disable.value = false;
      Clear4disable.value = true;
      Clear5disable.value = true;
      Change2disable.value = false;
      Change3disable.value = false;
      Change4disable.value = false;
      Change5disable.value = true;
    } 
    
    if(distributorConfirmer4Id.value.length != 0){
      Clear1disable.value = true;
      Clear2disable.value = true;
      Clear3disable.value = true;
      Clear4disable.value = false;
      Clear5disable.value = true;
      Change2disable.value = false;
      Change3disable.value = false;
      Change4disable.value = false;
      Change5disable.value = false;
    } 
    else{
      distributorConfirmer4IdName.value = "";
    } 
    if(distributorConfirmer5Id.value.length != 0){
      Clear1disable.value = true;
      Clear2disable.value = true;
      Clear3disable.value = true;
      Clear4disable.value = true;
      Change2disable.value = false;
      Change3disable.value = false;
      Change4disable.value = false;
      Clear5disable.value = false;
    } 
    
    if (distributorConfirmer1Id.value.length == 0 && distributorConfirmer2Id.value.length == 0 && distributorConfirmer3Id.value.length == 0 && distributorConfirmer4Id.value.length == 0 && distributorConfirmer5Id.value.length == 0){
      Clear1disable.value = true;
      Clear2disable.value = true;
      Clear3disable.value = true;
      Clear4disable.value = true;
      Clear5disable.value = true;
      Change2disable.value = true;
      Change3disable.value = true;
      Change4disable.value = true;
      Change5disable.value = true;
    }
}

const btnClear = (txtID : any) => {
    if(txtID =="APPROVER"){
      approverId.value ="";
      approverDataId.value ="";
    }
    else if(txtID =="CONFIRMER"){
      smcConfirmerId.value ="";
      confirmerId.value ="";
    }
    else if(txtID !="APPROVER" && txtID !="CONFIRMER"){
      let distributorConfirmer = {
        CONFIRMER1:distributorConfirmer1Id,
        CONFIRMER2:distributorConfirmer2Id,
        CONFIRMER3:distributorConfirmer3Id,
        CONFIRMER4:distributorConfirmer4Id,
        CONFIRMER5:distributorConfirmer5Id,
        DISTRIBUTER:distributorApproverId
      }
      for (let key in distributorConfirmer){
        if (key == txtID){
          (distributorConfirmer as any)[key].value ="";
        }
      }
      let distributorConfirmerData = {
        CONFIRMER1:distributorConfirmer1IdName,
        CONFIRMER2:distributorConfirmer2IdName,
        CONFIRMER3:distributorConfirmer3IdName,
        CONFIRMER4:distributorConfirmer4IdName,
        CONFIRMER5:distributorConfirmer5IdName,
        DISTRIBUTER:distributorApproverIdName
      }
      for (let key in distributorConfirmerData){
        if (key == txtID){
          (distributorConfirmerData as any)[key].value ="";
        }
      }
      approverStation.value ="";
    }
    checkBtnStart();
    checkBtnClear();
}

const checkBtnStart = () => {
    if(approverId.value.length != 0 && distributorApproverId.value.length != 0 ){
     Ketteidisable.value = false;
    }
    else{
     Ketteidisable.value = true;
    }
}

const chkCheckEvent = (info : any) => {
  radioCheckUserId.value = info.userId;
  radioCheckUserName.value = info.userName;
  stationData.value = info.stationCode_id + ' : ' + info.companyName;
  isCheckedOK.value = false;
};

const startConfirmationProcess = () => {
  const dupliConfirmer = reactive([]);
  let k = 0;
  if (distributorConfirmer1IdName.value !== "" && distributorConfirmer1IdName.value === distributorApproverIdName.value){
    showMessage("confirmer1");
  }
  else if (distributorConfirmer2IdName.value !== "" && distributorConfirmer2IdName.value === distributorApproverIdName.value){
    showMessage("confirmer2");
  }
  else if (distributorConfirmer3IdName.value !== "" && distributorConfirmer3IdName.value === distributorApproverIdName.value){
    showMessage("confirmer3");
  }
  else if (distributorConfirmer4IdName.value !== "" && distributorConfirmer4IdName.value === distributorApproverIdName.value){
    showMessage("confirmer4");
  }
  else if (distributorConfirmer5IdName.value !== "" && distributorConfirmer5IdName.value == distributorApproverIdName.value){
    showMessage("confirmer5");
  }
  else if (distributorConfirmer1IdName.value !== "" || distributorConfirmer2IdName.value !== "" ||
  distributorConfirmer3IdName.value !== "" || distributorConfirmer4IdName.value !== "" ||
  distributorConfirmer5IdName.value !== "" ){
    let distributorConfirmer = {
      1:distributorConfirmer1IdName,
      2:distributorConfirmer2IdName,
      3:distributorConfirmer3IdName,
      4:distributorConfirmer4IdName,
      5:distributorConfirmer5IdName
    }
    for (let i=1;i<5;i++){
      for (let j=i+1;j<6;j++){
        if ((distributorConfirmer as any)[i].value !="" && (distributorConfirmer as any)[j].value !=""){
          if ((distributorConfirmer as any)[i].value == (distributorConfirmer as any)[j].value){
            if (dupliConfirmer.length==0){
              dupliConfirmer[k]="confirmer"+i;
              dupliConfirmer[k+1]="confirmer"+j;
              k +=2;
            }
            if (!dupliConfirmer.includes(`confirmer${i}`)){
              dupliConfirmer[k]="confirmer"+i;
              k +=1;
            }
            if (!dupliConfirmer.includes(`confirmer${j}`)){
              dupliConfirmer[k]="confirmer"+j;
              k +=1;
            }
          }
        }
      }
    }
    dupliConfirmer.sort();
    let strmsg = "Overlapping ";
    if (dupliConfirmer.length != 0){
      if (dupliConfirmer.length > 2 ){
        for (let I=0;I<dupliConfirmer.length;I++){
          if((dupliConfirmer.length-I) != 1){
            if((dupliConfirmer.length-I) != 2){
              strmsg = strmsg + dupliConfirmer[I] + ", ";
            }
            else{
              strmsg = strmsg + dupliConfirmer[I] + " and ";
            }
          }
          else{
            strmsg = strmsg + dupliConfirmer[I] ;
          }
        }
      }
      else if (dupliConfirmer.length ==2){
        strmsg = strmsg + dupliConfirmer[0] + " and " + dupliConfirmer[1];
      }
      alert(i18n.t("alt109").replace("message", strmsg));
    }
    else{
      mailSendProcess();
    }
  }
  else{
      mailSendProcess();
    }
}

const showMessage = (message : any) => {
  alert(i18n.t("alt108").replace("message", message));
}

/** 承認ユーザー一覧表示 */
const showModal = (param : any) => {
  modalSubject.splice(0);
  modalBody.splice(0);
  isChecked.value="";
  modalSubject.push("Setting Approval Route");
  txtUserId.value = "";
  checkUser.value = param;
  showUserDetail();
};

const showUserDetail = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  if (checkUser.value != "APPROVER" && checkUser.value != "CONFIRMER"){
    const userList = {
      functionName : "getUserList",
      userId : txtUserId.value,
      menuCD : menuCD.value,
      parentDistributorCode : distributorCodeData.value,
      chkMode : distributorCodeCheck.value
    }  
    isLoading.value = true;
    /** ステータス表示 */
    IssueSalesNoteDataService.getKDPUserListLmabda(userList)
      .then((response: ResponseData) => {
        for (let info of response.data) {
          modalBody.push(info);
        }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err107");
      alertState.value = "error";
      isLoading.value = false;
    });
  }
  else
  {
    const userList = {
      txtUserId : txtUserId.value,
      userId : store.getters.cognitoUserName
    }  
    isLoading.value = true;
    /** ステータス表示 */
    IssueSalesNoteDataService.getKDPUserList(userList)
      .then((response: ResponseData) => {
        if (response.data.length !== 0) {
          for (let info of response.data) {
            modalBody.push(info);
          }
        }
        isLoading.value = false;
      })
      .catch((e: Error) => {
        alertMessage.value = i18n.t("err107");
        alertState.value = "error";
        isLoading.value = false;
      });
  }
}

/** Cancelボタンイベント */
const goDetailSearch = () => {
  modalBody.splice(0);
  showUserDetail();
}

const goClose= () => {
  isCheckedOK.value=true;
}

const btnExit= () => {
  router.push("/KDPIssueSalesNote");
}

/** Cancelボタンイベント */
const goOK = () => {
  if(isChecked.value != ""){
    showUserName();
  }
  radioCheckUserId.value = "";
  radioCheckUserName.value = "";
  stationData.value = "";
  isCheckedOK.value = true;
}

const showUserName = () => {
  if(checkUser.value == "APPROVER"){
    approverDataId.value = radioCheckUserId.value;
    distributorApproverNameData.value = radioCheckUserName.value;
    approverId.value =  distributorApproverNameData.value + " (" + approverDataId.value +")"
  }
  else if(checkUser.value == "CONFIRMER"){
    confirmerId.value=radioCheckUserId.value;
    confirmNameData.value=radioCheckUserName.value;
    smcConfirmerId.value =  radioCheckUserName.value + " (" + radioCheckUserId.value +")";
  }
  else if(checkUser.value == "CONFIRMER1"){
    distributorConfirmer1Id.value =  radioCheckUserName.value + " (" + radioCheckUserId.value +")\n (" + stationData.value + ")";
    approverStation.value = stationData.value;
    distributorConfirmer1IdName.value =  radioCheckUserId.value; 
  }
  else if(checkUser.value == "CONFIRMER2"){
    distributorConfirmer2Id.value =radioCheckUserName.value + " (" + radioCheckUserId.value +")\n(" + stationData.value + ")";
    distributorConfirmer2IdName.value =  radioCheckUserId.value;
  }
  else if(checkUser.value == "CONFIRMER3"){
    distributorConfirmer3Id.value =radioCheckUserName.value + "(" + radioCheckUserId.value +")\n(" + stationData.value + ")";
    distributorConfirmer3IdName.value =  radioCheckUserId.value;
  }
  else if(checkUser.value == "CONFIRMER4"){
    distributorConfirmer4Id.value = radioCheckUserName.value + " (" + radioCheckUserId.value +")\n(" + stationData.value + ")";
    distributorConfirmer4IdName.value = radioCheckUserId.value;
  }
  else if(checkUser.value == "CONFIRMER5"){
    distributorConfirmer5Id.value = radioCheckUserName.value + " (" + radioCheckUserId.value +")\n(" + stationData.value + ")";
    distributorConfirmer5IdName.value =  radioCheckUserId.value;
  }
  else if(checkUser.value == "DISTRIBUTER"){
    distributorApproverId.value = radioCheckUserName.value + " (" + radioCheckUserId.value +")\n(" + stationData.value + ")";
    distributorApproverIdName.value = radioCheckUserId.value;
  }
  checkBtnStart();
  checkBtnClear();
}


const __returned__ = { isLoading, router, txtUserId, modalSubject, modalBody, isCheckedOK, isChecked, alertMessage, alertState, i18n, smcConfirmerId, approverId, approverDataId, distributorConfirmer1Id, distributorConfirmer2Id, distributorConfirmer3Id, distributorConfirmer4Id, distributorConfirmer5Id, distributorConfirmer1IdName, distributorConfirmer2IdName, distributorConfirmer3IdName, distributorConfirmer4IdName, distributorConfirmer5IdName, distributorApproverIdName, distributorApproverId, distributorApproverName, distributorApproverNameData, confirmNameData, distributorCode, Clear1disable, Change2disable, Clear2disable, Change3disable, Clear3disable, Change4disable, Clear4disable, Change5disable, Clear5disable, Ketteidisable, menuCD, radioCheckUserId, radioCheckUserName, checkUser, confirmerId, saleNoDataList, prodYmDataList, seqNoDataList, distributorDataList, btnFlag, stationData, approverStation, parentDistributorCode, distributorName, paramSalesNote, distributorCodeCheck, distributorCodeData, getIssueSalesNoteList, mailSendProcess, mailData, checkBtnClear, btnClear, checkBtnStart, chkCheckEvent, startConfirmationProcess, showMessage, showModal, showUserDetail, goDetailSearch, goClose, btnExit, goOK, showUserName, Navigation, store, Loading, Alert, SalesNoteLinkNavigation, SalesNoteHeaderNavigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})